import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { DuplicateSurveyDialog } from 'modules/engagement_surveys/components/DuplicateSurveyDialog'

type Data = {
  surveyId: string
}

export const DuplicateSurveyActivity: ActivityComponent<Data> = ({ surveyId }) => {
  const { open, closeActivity } = useActivity()
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  if (!open) return null

  return (
    <DuplicateSurveyDialog
      surveyId={Number(surveyId)}
      onSuccess={(newSurvey) => {
        closeActivity()
        navigate(navigation.engagement.smart_surveys.survey.fullPath({ surveyId: newSurvey.id }))
      }}
      onCancel={closeActivity}
    />
  )
}
